import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import TypeBox from './TypeBox';
import TypesList from './TypesList';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  popper: {
    zIndex: 999,
    width: 300,
    marginTop: 20,
    borderRadius: 3,
    border: '1px solid #EFEFEF',
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.9em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent #fff transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.9em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: `transparent transparent #fff transparent`,
      },
    },
  },
  paper: {
    boxShadow: '0 0 41px 0 rgba(0,0,0,0.10)',
    backgroundColor: '#fff',
    paddingBottom: 24,
  },
  arrow: {
    position: 'absolute',
    fontSize: 7,
    width: '3em',
    height: '3em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
  title: {
    padding: '24px 5px 24px 24px',
  },
});

class SearchTypes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      arrowRef: null,
    };
  }

  open = () => {
    this.setState({ open: true });
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };

  handleArrowRef = node => {
    this.setState({
      arrowRef: node,
    });
  };

  selectType = (slug, event, type, id) => {
    this.setState({ open: false });
    this.props.changeHandler(slug, event, type, id);
  };

  render() {
    const { data, classes, value } = this.props;
    const { open, arrowRef } = this.state;
    return (
      <div className={classes.root}>
        <TypeBox
          typeRef={node => {
            this.anchorEl = node;
          }}
          handleClick={this.open}
          value={value}
        />
        <Popper
          open={open}
          anchorEl={this.anchorEl}
          className={classes.popper}
          transition
          placement="bottom-start"
          modifiers={{
            flip: {
              enabled: false,
            },
            arrow: {
              enabled: true,
              element: arrowRef,
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: 'window',
            },
          }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="types-list-grow"
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <>
                <span className={classes.arrow} ref={this.handleArrowRef} />
                <Paper className={classes.paper}>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <div>
                      <TypesList
                        types={data}
                        selectType={this.selectType}
                        selectedValue={value}
                      />
                    </div>
                  </ClickAwayListener>
                </Paper>
              </>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

SearchTypes.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.array,
  value: PropTypes.string,
  changeHandler: PropTypes.func,
};

export default compose(
  withStyles(styles),
  withRouter,
)(SearchTypes);
